module.exports = __webpack_public_path__ + "img/audio-mark10.103cd7f3.png";